module.exports = __webpack_public_path__ + "media/images/people/girl-6-a8a6b668e7671ab0bc30f97cb5d3cdbe.webp";